<template>
	<div class='board'>
		<div class='tile' 
			v-bind:class='visibility(i)'
			v-for='i in index' v-bind:key='i'
			v-on:mousedown='click(i)'
			:style="{
				top: Math.floor(tiles.pos[i]/3) *200 +10+ 'px',
				left: (tiles.pos[i]%3)*200 +10+ 'px'
			}">
			{{ i+1 }}
		</div>
	</div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import Tiles from '../Tiles'

export default defineComponent({
	name: 'Board',
	props: {
		gameState: String,
		mode: String,
	},
	data: () => ({
		index: [0,1,2,3,4,5,6,7],
		tiles: new Tiles(),
	}),
	methods: {
		click: function(i: number) {
			if (this.gameState === 'memorize') {
				this.$emit('playingStart')
			}
			if (this.tiles.moveIfAble(i)) {
				this.$emit('countUp')
				if (this.tiles.checkFinish()) {
					this.$emit('finish')
				}
			} else {
				// 動かない場合のフィードバック（揺らすとか？）
			}
		},
		visibility: function(i: number) {
			if (this.mode === 'open') return 'visible'
			if (this.gameState === 'level-select') return 'visible'

			if (this.gameState === 'memorize' || this.gameState === 'finish' || this.gameState === 'giveup') {
				if (this.mode === 'hidden') return 'semivisible'
				if (this.mode === 'even' && i % 2 === 1) return 'semivisible'
				return 'visible'
			}

			if (this.gameState === 'playing') {
				if (this.mode === 'hidden') return 'invisible'
				if (this.mode === 'even' && i % 2 === 1) return 'invisible'
				return 'visible'
			}
		}
	},
	watch: {
		gameState: function(newState, oldState) {
			if (newState === 'memorize') {
				this.tiles.shuffle()
			} 
		}
	},
})
</script>

<style scoped>
.board {
	width: 600px;
	height: 600px;
	position: relative;
}

.tile {
	background-color: #ffcc55;
	background-image: url('../assets/bg.jpg');
	width: 180px;
	height: 180px;
	border-top: solid 2px #dddddd;
    border-left: solid 2px #dddddd;
	position: absolute;

	font-size: 100px;
	font-weight: bold;
	text-align: center;
	line-height: 180px;
	transition: all 100ms 0s ease;

	cursor: pointer;
}

.visible {
	color: rgba(0, 0, 0, 1);
}
.semivisible {
	color: rgba(0, 0, 0, 0.5);
}
.invisible {
	color: rgba(0, 0, 0, 0);
}

</style>